<!--  -->
<template>
  <div class="agreement_c">
    <div class="main_title">工程师管理规范</div>
    <p class="main_synopsis" style="font-weight: 600">
      工程师入驻平台后开始接单前，务必了解本服务操作规则。部分违规服务操作，将影响您在平台的接单优先级和质保金，如您在神州邦邦接取订单则视为已同意本费用规则。
    </p>
    <div class="main_item">
      <h2>一、&nbsp;预约上门</h2>
      <ul class="content_wrap1">
        <li>
          <p>平台订单均须在工程师接单后2小时内与雇主预约上门时间</p>
        </li>
        <li>
          <h4>预约雇主时需要确认的事项及要求</h4>
          <ul class="content_wrap2">
            <li>
              <p>
                预约雇主时，请主动表明身份（订单顾问会提前告知工程师此订单代表身份，如：神州邦邦工程师或XX公司售后），需热情问好,与雇主确认施工地址是否和订单地址一致，设备、辅材是否已经到齐。
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>工程师和雇主预约后，按照与雇主真实沟通结果填写预约信息</p>
          <p>
            与雇主沟通并就上门时间达成一致后，工程师必须如实在APP端通过定位打卡，标记上门时间。
          </p>
        </li>
        <li>
          <p>如何修改预约时间:</p>
          <p>
            当工程师完成预约后，因工程师原因需要临时更改上门时间，工程师再需提前1天与用户沟通说明原因，在雇主同意修改时间后，与平台订单顾问联系，告知更改后的时间，若雇主不同意修改，需与与平台订单顾问联系，更换接单工程师。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>二、&nbsp;上门前操作规范及要求</h2>
      <p>工程师必须按预约时间准时上门</p>
      <ul class="content_wrap1">
        <li>
          <p>
            上门前，必须提前三个小时致电雇主确认是否能够准时施工，并与雇主确认设备、辅材是否准备齐全，以避免空跑或等待；
          </p>
        </li>
        <li>
          <p>
            如工程师因不可抗力因素导致不能准时上门，必须至少提前3个小时致电雇主协商延迟上门时间或更改上门时间，若协商未达成一致，必须立即反馈订单顾问进行应急处理。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>三、&nbsp;上门后操作规范及要求</h2>
      <p>操作规范：</p>
      <ul class="content_wrap1">
        <li>
          <p>
            上门后先自我介绍，告知雇主身份，并与雇主或确认工作内容。（订单顾问会提前告知工程师此订单代表身份，如：神州邦邦工程师或XX公司售后）
          </p>
        </li>
        <li>
          <p>服务前工作规范：</p>
          <p>清点施工所需的物品，确认齐全再开始操作</p>
          <p>
            注意：如现场因雇主原因不具备施工条件，请立刻反馈平台客服，待确认后再开始操作。
          </p>
          <p>服务前必须与雇主确认施工位置及施工环境再开始操作。</p>
        </li>
        <li>
          <p>服务中工作规范:</p>
          <p>
            开始施工前先确认工作内容，是否增加工作内容，再按照约定服务内容施工，需用到雇主设备或物品时需提前与雇主沟通，经雇主允许后方可操作雇主设备、器材，避免因设备损坏造成纠纷。服务过程需注意行为举止，避免大声喧哗，遵守哦用户现场管理规定，提升雇主方体验。
          </p>
          <p>
            如有订单约定外的需求，请及时与雇主沟通确认，如需要调整服务费，先与平台订单顾问沟通报备，订单顾问将调整订单服务金额。
          </p>
        </li>
        <li>
          <p>服务后工作规范：</p>
          <p>整理工具，清理卫生，拍摄实施照片，联系雇主开始验收。</p>
        </li>
      </ul>
      <p>服务要求：</p>
      <ul class="content_wrap1">
        <li>
          <p>在服务过程中禁止向雇主推销其他服务商、其他产品。</p>
        </li>
        <li>
          <p>禁止未经用户允许操作用户设备、器材，如设备有损坏，需按价赔偿。</p>
        </li>
        <li>
          <p>禁止未经允许使用用户信息（照片、文档等）。</p>
        </li>
        <li>
          <p>
            因工程师过度承诺，造成接单后不能按雇主要求完成订单的，平台将对工程师降权操作，影响后续接单排名。
          </p>
        </li>
        <li>
          <p>
            工程师不得以任何理由收受用户钱财、物品等，如用户主动提出应答立即拒绝。
          </p>
        </li>
        <li>
          <p>工程师不得直接跟雇主索要服务费。</p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>四、&nbsp;服务验收</h2>
      <p>
        工程师完成订单中约定的工作后，雇主对实施项目进行验收，主要有以下三种验收方式：
      </p>
      <ul class="content_wrap1">
        <li>
          <p>
            雇主现场电子签字验收。用工程师手机设备在“服务结果反馈”页面选择“现场电子签字”，填写雇主预留手机号码接到的验证码，雇主签字确认；
          </p>
        </li>
        <li>
          <p>
            雇主App 确认验收。雇主在 APP
            或者微信小程序中，对该笔订单操作确认验收。
          </p>
        </li>
        <li>
          <p>
            纸介质服务单签字验收。雇主与工程师签署服务单，并在神州邦邦APP中上传实施图片和服务单，完成验收。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>五、&nbsp;服务质保期</h2>
      <p>
        工程师在平台提供的服务包含30天质保期，质保期内订单中服务内容出现问题，工程师服务验收完成可申请提现，申请提现质保期如无售后申请，可提现至工程师账户。
      </p>
      <p>质保期问题处理流程：</p>
      <p>
        质保期内订单出现质量问题，雇主反馈给平台后，平台将于工程师联系告知问题，工程师需与雇主沟通，优先采取远程指导的方式确认并解决问题，雇主有上门需求的，需以上门服务方式解决问题，质保期订单费雇主原因出现问题，工程师不再收取费用。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>